import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";

export default function FloatingActionButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
        setIsExpanded(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const callPhone = () => {
    window.open("tel:+919512170618", "_self");
  };

  const openWhatsApp = () => {
    window.open("https://wa.me/919512170618", "_blank");
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end space-y-3">
          {/* Additional Action Buttons */}
          <AnimatePresence>
            {isExpanded && (
              <motion.div
                className="flex flex-col space-y-3"
                initial={{ opacity: 0, scale: 0.8, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.8, y: 20 }}
                transition={{ duration: 0.2 }}
              >
                <motion.button
                  onClick={scrollToTop}
                  className="w-12 h-12 bg-accent hover:bg-accent/90 text-white rounded-full shadow-lg flex items-center justify-center hover-cursor"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  title="Back to Top"
                >
                  <i className="fas fa-arrow-up"></i>
                </motion.button>

                <motion.button
                  onClick={scrollToContact}
                  className="w-12 h-12 bg-blue-500 hover:bg-blue-600 text-white rounded-full shadow-lg flex items-center justify-center hover-cursor"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  title="Contact Us"
                >
                  <i className="fas fa-envelope"></i>
                </motion.button>

                <motion.button
                  onClick={callPhone}
                  className="w-12 h-12 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg flex items-center justify-center hover-cursor"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  title="Call Us"
                >
                  <i className="fas fa-phone"></i>
                </motion.button>

                <motion.button
                  onClick={openWhatsApp}
                  className="w-12 h-12 bg-green-600 hover:bg-green-700 text-white rounded-full shadow-lg flex items-center justify-center hover-cursor"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  title="WhatsApp"
                >
                  <i className="fab fa-whatsapp"></i>
                </motion.button>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Main FAB */}
          <motion.button
            onClick={() => setIsExpanded(!isExpanded)}
            className="w-14 h-14 bg-primary dark:bg-accent text-white rounded-full shadow-xl flex items-center justify-center hover-cursor"
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ duration: 0.3 }}
          >
            <motion.i
              className={`fas ${isExpanded ? 'fa-times' : 'fa-plus'}`}
              animate={{ rotate: isExpanded ? 45 : 0 }}
              transition={{ duration: 0.2 }}
            />
          </motion.button>
        </div>
      )}
    </AnimatePresence>
  );
}